import { FieldType } from "../../../../../model/service-request/attribute";
import { DynamicFieldItem } from "../../../../../model/dynamic-forms";
import { useServiceRequestForm } from "../../context/ServiceRequestFormContext";
import { StepProps } from "../../informations";
import styles from "./steps.module.scss";
import { formatCurrency } from "../../../../../utils";

const getDisplayValue = (field: DynamicFieldItem): string => {
    switch (field.fieldType) {
        case FieldType.Bool:
            return field.fieldValue ? "Yes" : "No";
        case FieldType.File:
        case FieldType.Image:
            return field.fileFileName ?? "—";
        case FieldType.Dropdown:
        case FieldType.SingleSelect:
        case FieldType.ConditionalDropdown:
        case FieldType.ChildDropdown:
        case FieldType.MultiSelect:
            return field.dropdownText ?? field.fieldValue ?? "—";
        default:
            return field.fieldValue !== null && field.fieldValue !== undefined && field.fieldValue !== ""
                ? String(field.fieldValue)
                : "—";
    }
};

const ConfirmRow = ({ label, value }: { label: string; value: string }) => (
    <div className={styles.confirmRow}>
        <span className={styles.confirmLabel}>{label}</span>
        <span className={styles.confirmValue}>{value || "—"}</span>
    </div>
);

const ConfirmationStep = ({ title, message }: StepProps) => {
    const { form: { getValues } } = useServiceRequestForm();
    const { firstName, lastName, email, phone, homeAddress, meterNumber, requestTypeName, sections, amount } = getValues();

    const allFields = Object.values(sections).flat();

    return (
        <div className={styles.mainStepContent}>
            <div className={styles.headerContainer}>
                <h2 className={styles.headerTitle}>{title}</h2>
                <p className={styles.headerDescription}>{message}</p>
            </div>

            <div className={styles.formContainer}>
                <ConfirmRow label="First Name" value={firstName} />
                <ConfirmRow label="Last Name" value={lastName} />
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <ConfirmRow label="Email" value={email} />
                <ConfirmRow label="Phone Number" value={phone} />
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <ConfirmRow label="Home Address" value={homeAddress} />
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <ConfirmRow label="Meter Number" value={meterNumber} />
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <ConfirmRow label="Request Type" value={requestTypeName} />
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <ConfirmRow label="Amount" value={formatCurrency(amount?.amount ?? 0, { currency: amount?.currency })} />
            </div>
            {allFields.length > 0 && (
                <>
                    <hr className={styles.divider} />
                    <div className={styles.formContainer}>
                        {allFields.map((field) => (
                            <ConfirmRow
                                key={field.fieldId}
                                label={field.fieldLabel}
                                value={getDisplayValue(field)}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ConfirmationStep;
